
/**
 * 투표 생성 시 선택지 정보
 */
export type CreateTweetBodyJsonDataPollOptionsItem = {
  /**
   * 투표 선택지 텍스트
   * @maxLength 25
   */
  text: string;
};
